import { IGlobalState } from '../../../Root/store/appReducer'
import { Role, UserDto } from '../../../services/api.types'

export const getCompanyUsersList = (state: IGlobalState) =>
  state.userManagement.companyUsers.filter((user) => user.role === Role.USER)

export const getCompanyUsersWithRoles = (state: IGlobalState) => {
  const users = state.userManagement.companyUsers
  const userMap = new Map<string, UserDto>()

  // First pass: add only users with USER role to the map (exclude ADMIN-only users)
  users.forEach((user) => {
    if (user.role === Role.USER) {
      userMap.set(user.userId, { ...user })
    }
  })

  // Second pass: update role to ADMIN for users that have both roles
  users.forEach((user) => {
    if (user.role === Role.ADMIN) {
      const existingUser = userMap.get(user.userId)
      if (existingUser) {
        // User exists in the map (has USER role), update to ADMIN
        userMap.set(user.userId, { ...existingUser, role: Role.ADMIN })
      }
      // Skip if user doesn't exist in map (ADMIN-only user)
    }
  })

  return Array.from(userMap.values())
}

export const getCompanyUsersLoading = (state: IGlobalState) => state.userManagement.usersLoading
export const getLastDivisionSet = (state: IGlobalState) => state.userManagement.lastDivisionSet
export const getBulkDeleteInProgress = (state: IGlobalState) => state.userManagement.bulkDeleteInProgress
export const getAdminRoleInProgress = (state: IGlobalState) => state.userManagement.adminRoleInProgress
